import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.number.constructor";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as d3 from 'd3';
import { themesMixin } from '../../../utils/themes';
import { fixedDecimals } from '../../../utils/vuex';
import drawTextMixin from './d3textMixin.js';
export default {
  name: 'CoreChartGaugeModern',
  mixins: [drawTextMixin, themesMixin],
  props: {
    size: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    unit: {
      type: String,
      default: ''
    },
    thresholds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    thresholdColors: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    reverse: {
      type: Boolean,
      default: false
    },
    fixTo: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    return {
      bgColor: '#bdbdbd',
      svgSize: 180,
      arcRange: 270
    };
  },
  computed: {
    color: function color() {
      return this.vuetifyColorHex();
    },
    textColor: function textColor() {
      return this.$store.state.app.UiTheme ? '#ccc' : '#333';
    },
    segmentValues: function segmentValues() {
      return [this.min].concat(_toConsumableArray(this.sanitizesThresholds), [this.max]);
    },
    sanitizesThresholds: function sanitizesThresholds() {
      var _this = this;

      // filter out thresholds that are outside of the min/max values
      return this.thresholds.filter(function (item) {
        return !(item <= _this.min || item >= _this.max);
      }).sort(function (a, b) {
        return a - b;
      });
    }
  },
  watch: {
    size: function size() {
      this.draw();
    },
    value: function value() {
      this.draw();
    },
    min: function min() {
      this.draw();
    },
    max: function max() {
      this.draw();
    },
    segmentValues: function segmentValues() {
      this.draw();
    },
    color: function color() {
      this.draw();
    },
    textColor: function textColor() {
      this.draw();
    },
    reverse: function reverse() {
      this.draw();
    },
    fixTo: function fixTo() {
      this.draw();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.draw();
    });
  },
  methods: {
    deg2Rad: function deg2Rad(deg) {
      return deg * (Math.PI / 180);
    },
    getColorArray: function getColorArray() {
      var colors = [// colors when no thresholds are there
      ['#ff1744', '#fb8c00', '#fec60a', '#7cb342', '#388e3c']];
      var colorArray = this.thresholdColors.length ? this.thresholdColors : colors[0];
      return colorArray;
    },

    /* eslint-disable max-statements */
    draw: function draw() {
      var _this3 = this;

      var offsetTop = 14; // to center the gauge vertically as it is not a full cirlce

      var angleScale = d3.scaleLinear().range([-135, 135]);
      var value2Angle = angleScale.domain([this.min, this.max]); // clear existing svg content

      d3.select(this.$el).selectAll('*').remove(); // render "N/A" if value is not a number

      if (isNaN(parseFloat(this.value))) {
        return this.drawNotAvailable();
      }

      var svg = d3.select(this.$el).attr('width', this.size || '100%').attr('height', this.size || '100%').attr('viewBox', "0 0 ".concat(this.svgSize + 2, " ").concat(this.svgSize + 2)).append('g').attr('transform', "translate(".concat(this.svgSize / 2, ", ").concat(this.svgSize / 2 + offsetTop, ")"));
      var color = d3.scaleThreshold().domain(this.sanitizesThresholds).range(this.getColorArray(this.sanitizesThresholds));
      var arcSegmentData = this.segmentValues.map(function (d, i) {
        var startAngle = angleScale(_this3.segmentValues[i]);
        var endAngle = angleScale(_this3.segmentValues[i + 1] === undefined ? _this3.segmentValues[i] : _this3.segmentValues[i + 1]);
        return {
          color: color(d),
          startAngle: _this3.deg2Rad(startAngle),
          endAngle: _this3.deg2Rad(endAngle)
        };
      });
      var radius = this.svgSize / 2; // arc main - background

      var arcMain = d3.arc().startAngle(this.deg2Rad(value2Angle(this.min))).innerRadius(radius - 30).outerRadius(radius - 10);
      svg.append('path').attr('d', arcMain.endAngle(this.deg2Rad(value2Angle(this.max)))).attr('fill', this.bgColor); // arc main - gauge value

      var arcValue = d3.arc().startAngle(this.deg2Rad(value2Angle(this.min))).innerRadius(radius - 30).outerRadius(radius - 10); // keep value between min and max so the arc does not break

      var valueSanitized = Math.min(Math.max(this.min, this.value), this.max);
      svg.append('path').attr('d', arcValue.endAngle(this.deg2Rad(value2Angle(valueSanitized)))).attr('fill', this.sanitizesThresholds.length < 1 ? this.color : color(valueSanitized));

      if (this.sanitizesThresholds.length < 1) {
        // draw gray solid outer ring
        var _arcMain = d3.arc().startAngle(this.deg2Rad(angleScale(this.min))).innerRadius(radius - 5).outerRadius(radius);

        svg.append('path').attr('d', _arcMain.endAngle(this.deg2Rad(angleScale(this.max)))).attr('fill', this.bgColor);
      } else {
        // draw colored ring per thresholds
        var outerArc = svg.append('g').attr('class', 'arc-thresholds');
        var id = Math.floor(new Date() / 1000 * Math.random());

        for (var _idx = 0; _idx < arcSegmentData.length - 1; _idx++) {
          var _d = arcSegmentData[_idx];
          var arcSegment = d3.arc().startAngle(_d.startAngle).innerRadius(radius - 5).outerRadius(radius);
          outerArc.append('path').attr('d', arcSegment.endAngle(_d.endAngle)).attr('fill', _d.color).attr('class', 'arc-threshold-value').attr('id', "".concat(id).concat(_idx));
          outerArc.append('text').style('font-size', '14px').attr('dy', '-0.25em').append('textPath').attr('xlink:href', "#".concat(id).concat(_idx)).style('text-anchor', 'start').attr('startOffset', '0%').attr('fill', this.textColor).text(this.segmentValues[_idx]);
        }

        var d = arcSegmentData[arcSegmentData.length - 2];
        var idx = arcSegmentData.length;
        var hiddenArc = d3.arc().startAngle(d.startAngle).innerRadius(radius - 5).outerRadius(radius);
        outerArc.append('path').attr('d', hiddenArc.endAngle(d.endAngle)).attr('fill', 'none').attr('class', 'arc-threshold-value').attr('id', "".concat(id).concat(idx));
        outerArc.append('text').style('font-size', '14px').attr('dy', '-0.25em').append('textPath').attr('xlink:href', "#".concat(id).concat(idx)).style('text-anchor', 'end').attr('startOffset', '50%').attr('fill', this.textColor).text(this.segmentValues[idx - 1]);
      } // eslint-disable-next-line no-irregular-whitespace


      var space = this.unit === '%' || this.unit.startsWith('°') ? '' : ' ';
      var fixedValue = fixedDecimals(this.value, this.fixTo);
      this.drawText(this.unit ? "".concat(fixedValue).concat(space).concat(this.unit) : fixedValue, {
        fontColor: this.textColor,
        x: 40,
        y: 0 + offsetTop,
        width: this.svgSize - 80,
        height: this.svgSize
      });
    }
  }
  /* eslint-enable max-statements */

};